<template>
  <div class="step-two">
    <van-collapse v-model="activeNames">
      <van-collapse-item :title="$t('form.basicInfo')" name="1">
        <div v-if="eventType == 2" class="form-item">
          <div class="label required">
            <span>{{ $t('form.distributorName') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.sdName" :disabled="isDisable" placeholder="" :border="false" class="custom-field" />
        </div>
        <div v-else class="form-item">
          <div class="label required">
            <span>{{ $t('form.storeName') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.customerName" :disabled="isDisable" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label required">
            <span>{{ $t('form.address') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field readonly v-model="customer.address" :disabled="isDisable" placeholder="" :border="false" class="custom-field" @click="getAddress" />
        </div>
        <div class="form-item">
          <div class="label required">
            <span>{{ $t('form.outsidePicture') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-uploader v-model="customer.imgUrl" max-count="1" :disabled="isDisable" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
        </div>
        <!-- <div class="form-item" v-if="!['event'].includes(pageType)">
          <div class="label">Assigned BA / BD</div>
          <XuSelect v-model="customer.dutyId" :fieldNames="{label: 'nickName', value: 'id'}" :dataOptions="globalData.userOptions" />
        </div> -->
        <div v-if="eventType == 1" class="form-item">
          <div class="label required">
            <span>{{ $t('form.storeType') }}</span>
          </div>
          <XuSelect v-model="customer.customerType" :dataOptions="customerTypeList" :disabled="isDisable" />
        </div>
        <div v-if="eventType == 1" class="form-item">
          <div class="label required">
            <span>{{ $t('form.businessStatus') }}</span>
          </div>
          <XuSelect v-model="customer.status" :dataOptions="statusList" :disabled="isDisable" />
        </div>
        <div v-if="eventType == 2" class="form-item">
          <div class="label required">
            <span>{{ $t('form.distributorTag') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuSelect v-model="customer.sdTag" :dataOptions="sdTagList" :disabled="isDisable" />
        </div>
        <div v-if="eventType == 2" class="form-item">
          <div class="label required">
            <span>{{ $t('form.distributorType') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuSelect v-model="customer.sdType" :multiple="true" :dataOptions="dTypeList" :disabled="isDisable" />
        </div>
        <div v-if="eventType == 2" class="form-item">
          <div class="label required">
            <span>{{ $t('form.businessType') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuSelect v-model="customer.businessType" :dataOptions="globalData.sdBusinessType" :disabled="isDisable" />
        </div>
        <div v-if="eventType == 1" class="form-item">
          <div class="label required">
            <span>{{ $t('form.chainOrNot') }}</span>
          </div>
          <van-field class="custom-field custom-radio-field">
            <template #input>
              <van-radio-group v-model="customer.isChain" direction="horizontal">
                <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value" :disabled="isDisable">{{ subItem.label }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div class="form-item" v-if="eventType == 1 && customer.isChain === true">
          <div class="label required">
            <span>{{ $t('form.numberofChainStores') }}</span>
          </div>
          <van-field v-model.number="customer.chainCount" type="digit" placeholder="" :disabled="isDisable" :border="false" class="custom-field" />
        </div>
        <div class="subset-form-item" v-if="eventType == 1 && customer.isChain === true">
          <div class="label required">
            <span>{{ $t('shared.distributor') }}</span>
          </div>
          <div class="select-field custom-field" @click="toSelectStoreSd('reorderList')">
            {{ customer.belongSd.sdName }}
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item :title="$t('form.decisionMakerInfo')" name="2">
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.decisionMakerName') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="decisionContact.contactName" :disabled="isDisable" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.decisionMakerRole') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuSelect v-model="decisionContact.job" :dataOptions="jobList" :disabled="isDisable" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.phone') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="decisionContact.phone" type="number" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.email') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="decisionContact.email" :disabled="isDisable" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.notes') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="decisionContact.remark" :disabled="isDisable" placeholder="" :border="false" class="custom-field" />
        </div>
      </van-collapse-item>
      <van-collapse-item title="Foot Traffic Information" name="3">
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.weekdayFootTraffic') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.weekdayTraffic" :disabled="isDisable" placeholder="" type="number" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.weekdayPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuTime v-model="customer.weekdayPeakTrafficTime" :disabled="isDisable" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.weekendFootTraffic') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.weekendTraffic" :disabled="isDisable" placeholder="" type="number" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.weekendPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuTime v-model="customer.weekendPeakTrafficTime" :disabled="isDisable" />
        </div>
      </van-collapse-item>
      <van-collapse-item :title="`${eventType == 2 ? 'Distributor' : 'Store'} Customer Reach`" name="4">
        <div v-if="eventType == 2" class="form-item">
          <div class="label custom-label">
            <span>{{ $t('form.numberOfAffiliatedCoreStore') }}</span>
            <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.coreStoreCount" maxlength="100" placeholder="" :disabled="isDisable" :border="false" class="custom-field" />
        </div>
        <div v-if="eventType == 2" class="form-item">
          <div class="label custom-label">
            <span>{{ $t('form.corePromotedProductBrand') }}</span>
            <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field v-model="customer.coreBrand" placeholder="" :border="false" class="custom-field" />
        </div>
        <div v-else class="form-item">
          <div class="label custom-label">
            <span>{{ $t('form.disposableBrandDiversity') }}</span>
            <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <XuSelect v-model="customer.disposableBrandDiversity" :dataOptions="brandDiersityList" :disabled="isDisable" />
          <div class="brand-diversity-tips">
            <div v-for="(subItem, subIndex) in brandDiersityTips" :key="subIndex" class="tips-item">
              <van-icon v-if="subIndex === 0" name="info-o" size="13" class="info-icon" color="#307bff" />
              <span>{{ subItem }}</span>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item :title="`${eventType == 2 ? $t('shared.distributor') : $t('shared.store')} ${$t('form.promotionCapabillty')}`" name="5">
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.officialWebsiteAvailable') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field class="custom-field custom-radio-field">
            <template #input>
              <van-radio-group v-model="customer.isOnlineWeb" :disabled="isDisable" direction="horizontal">
                <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.whatsAppGroupAvailable') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field class="custom-field custom-radio-field">
            <template #input>
              <van-radio-group v-model="customer.isWhatsappGroup" :disabled="isDisable" direction="horizontal">
                <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.facebookInstagramAvailable') }}</span>
            <img v-show="pageType === 'event'" class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
          <van-field class="custom-field custom-radio-field">
            <template #input>
              <van-radio-group v-model="customer.isIns" :disabled="isDisable" direction="horizontal">
                <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import XuTime from '@/components/XuTime.vue'
import { Toast, Dialog } from 'vant'
import { arsCustomerUpdateInfoApi } from '@/api/home'
import { updateInfoApi } from '@/api/salesDistribution'
import { mapState } from 'vuex'
export default {
  props: {
    customerId: {
      type: String,
      default: ''
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    eventType: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    XuSelect: () => import('@/components/XuSelect'),
    XuTime
  },
  data () {
    return {
      pageType: 'event',
      activeNames: ['1'],
      customer: {
        lng: '',
        lat: '',
        customerName: '',
        sdName: '',
        address: '',
        imgUrl: [],
        customerType: '',
        status: '',
        sdTag: '',
        sdType: [],
        businessType: '',
        isChain: '',
        chainCount: '',
        dutyId: '',
        weekdayTraffic: '',
        weekdayPeakTrafficTime: [{ start: '', end: '' }],
        weekendTraffic: '',
        weekendPeakTrafficTime: [{ start: '', end: '' }],
        disposableBrandDiversity: '',
        coreStoreCount: '',
        coreBrand: '',
        isOnlineWeb: '',
        isWhatsappGroup: '',
        isIns: '',
        belongSd: {
          id: '',
          sdName: ''
        }
      },
      decisionContact: {
        contactName: '',
        job: '',
        phone: '',
        email: '',
        remark: ''
      },
      retailPriceList: [],
      jobList: [],
      shelfList: [],
      listingStatusList: [],
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      brandDiersityList: [
        { label: this.$t('shared.filter.rich'), value: 'Rich' },
        { label: this.$t('shared.filter.good'), value: 'Good' },
        { label: this.$t('shared.filter.poor'), value: 'Poor' }
      ],
      brandDiersityTips: [
        this.$t('shared.filter.richTop'),
        this.$t('shared.filter.goodTop'),
        this.$t('shared.filter.poorMainly')
      ],
      sdTagList: [
        { label: this.$t('form.keyDistributor'), value: 1 },
        { label: this.$t('form.notKeyDistributor'), value: 0 }
      ],
      dTypeList: [
        { label: this.$t('shared.filter.mD'), value: 'MD' },
        { label: this.$t('shared.filter.kA'), value: 'KA' },
        { label: this.$t('shared.filter.sDSmokeDistro'), value: 'SD(Smoke Distro)' },
        { label: this.$t('shared.filter.sDMultiItemDistro'), value: 'SD(Multi-item Distro)' }
      ],
      customerTypeList: [],
      statusList: [
        { label: this.$t('form.business'), value: 1 }, // 正常营业
        { label: this.$t('form.temporarilyClosed'), value: -1 }, // 暂时性歇业
        { label: this.$t('form.permanentlyClosed'), value: -2 }, // 永久性歇业
        { label: this.$t('form.invalid'), value: -3 } // 无效数据
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    })
  },
  activated () {
    this.customerTypeList = []
    this.globalData.customerTypeList.forEach(subItem => {
      this.customerTypeList.push({ label: subItem.label, value: subItem.value })
    })
    this.initData()
  },
  methods: {
    checkVerify () {
      return this.checkedForm()
    },
    sendData () {
      const { imgUrl, weekdayPeakTrafficTime, weekendPeakTrafficTime, sdType } = this.customer
      const data = {
        customer: {
          ...this.customer,
          imgUrl: imgUrl.map(imgItem => imgItem.url).join(','),
          weekdayPeakTrafficTime: weekdayPeakTrafficTime.length <= 0 ? '' : weekdayPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          weekendPeakTrafficTime: weekendPeakTrafficTime.length <= 0 ? '' : weekendPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          id: this.customerId,
          sdType: sdType.join(',')
        },
        decisionContact: this.decisionContact
      }
      return data
    },
    getUpdateInfo (customerId = '') {
      if (JSON.parse(localStorage.getItem('centerPoint'))) return
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const requestApi = this.eventType === 2 ? updateInfoApi : arsCustomerUpdateInfoApi
      requestApi(this.customerId).then(res => {
        Toast.clear()
        const { customer, sd, decisionContact, retailPriceList, shelfList } = res.data
        this.retailPriceList = retailPriceList
        const formData = this.eventType === 2 ? sd : customer
        if (this.eventType === 2) {
          if (!sd.dutyId) {
            this.customer.dutyId = this.userInfo.user.id
          }
          // this.shelfList = shelfList
        } else {
          // shelfList.forEach(subItem => {
          //   subItem.shelfType = subItem.shelfType.length > 0 ? subItem.shelfType.split(',') : []
          // })
          // this.shelfList = shelfList
          if (!customer.dutyId) {
            this.customer.dutyId = this.userInfo.user.id
          }
        }
        if (this.customerId) {
          Object.keys(this.decisionContact).forEach(subItem => {
            this.decisionContact[subItem] = decisionContact[subItem] || ''
          })
          Object.keys(this.customer).forEach(subItem => {
            if (subItem === 'imgUrl') {
              this.customer[subItem] = formData[subItem] ? formData[subItem].split(',').map(imgItem => {
                return { url: imgItem }
              }) : []
            } else if (['weekdayPeakTrafficTime', 'weekendPeakTrafficTime'].includes(subItem)) {
              // '9:30~3:30,9:30~3:30' [9:30~3:30, 9:30~3:30]
              if (formData[subItem]) {
                const newTime = []
                const startEndTimeList = formData[subItem].split(',')
                startEndTimeList.forEach(timeItem => {
                  newTime.push({ start: timeItem.split('~')[0], end: timeItem.split('~')[1] })
                })
                this.customer[subItem] = newTime
              } else {
                this.customer[subItem] = [{ start: '', end: '' }]
              }
            } else if (subItem === 'sdType') {
              this.customer[subItem] = formData[subItem] !== '' ? formData[subItem].split(',') : []
            } else if (['belongSd'].includes(subItem)) {
              this.$set(this.customer, subItem, customer[subItem] || { id: '', sdName: '' })
            } else {
              // this.customer[subItem] = formData[subItem] || ''
              this.customer[subItem] = [undefined, null, ''].includes(formData[subItem]) ? '' : formData[subItem]
            }
          })
        }
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.customer[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    getAddress () {
      const query = {
        longitude: this.customer.lng || '',
        latitude: this.customer.lat || ''
      }
      this.$router.push({
        path: '/chooseLocation',
        query: query
      })
    },
    // 校验必填
    checkedForm () {
      const field = [
        { tipsText: this.$t('form.address'), value: 'address' },
        { tipsText: this.$t('form.outsidePicture'), value: 'imgUrl' }
      ]
      if (this.eventType !== 2) {
        field.unshift({ tipsText: this.$t('form.storeName'), value: 'customerName' })
      } else {
        field.unshift({ tipsText: this.$t('form.distributorName'), value: 'sdName' })
      }
      if (this.eventType === 2) {
        field.push({ tipsText: this.$t('form.distributorTag'), value: 'sdTag' })
        field.push({ tipsText: this.$t('form.distributorType'), value: 'sdType' })
        field.push({ tipsText: this.$t('form.businessType'), value: 'businessType' })
      } else {
        field.push({ tipsText: this.$t('form.storeType'), value: 'customerType' })
        field.push({ tipsText: this.$t('form.businessStatus'), value: 'status' })
        field.push({ tipsText: this.$t('form.chainOrNot'), value: 'isChain' })
        if (this.customer.isChain === true) {
          field.push({ tipsText: this.$t('form.numberofChainStores'), value: 'chainCount' })
          field.push({ tipsText: this.$t('shared.distributor'), value: 'id' })
        }
      }
      let isFlag = true
      field.find(subItem => {
        if (this.isEmptyVal(this.getFieldVal(subItem.value))) {
          isFlag = false
          Toast(`${subItem.tipsText} ${this.$t('tips.isRequired')}`)
          return true // find 只需返回 true 终止遍历，比 return subItem 语义清晰
        }
      })
      // this.shelfList.find(subItem => {
      //   if (subItem.isShelf && !subItem.shelfType) {
      //     isFlag = false
      //     Toast(`${subItem.label} is Required`)
      //     return subItem
      //   }
      // })
      return isFlag
    },
    // 空字符串 / 空数组 视为空
    isEmptyVal (val) {
      return val === '' || (Array.isArray(val) && val.length === 0)
    },
    getFieldVal (key) {
      if (key === 'id') return this.customer.belongSd.id
      return this.customer[key]
    },
    initData (customerId) {
      const centerPoint = JSON.parse(localStorage.getItem('centerPoint'))
      if (centerPoint) {
        this.customer.address = centerPoint.address
        this.customer.lng = centerPoint.lng
        this.customer.lat = centerPoint.lat
      }
      this.jobList = []
      this.listingStatusList = []
      this.globalData.customerJob.forEach(subItem => {
        this.jobList.push({ label: subItem.label, value: JSON.parse(subItem.value).val })
      })
      this.globalData.shelfType.forEach(subItem => {
        this.listingStatusList.push({ label: subItem.label, value: subItem.value })
      })
      // this.getUpdateInfo(customerId)
    },
    toSelectStoreSd (currKey, params) {
      const { id, sdName } = this.customer.belongSd
      window.localStorage.setItem('sdStoreSelect', JSON.stringify({ typeKey: currKey, typeValue: id ? [{ id: id, sdName: sdName }] : [] }))
      this.$router.push('/shared/selectStoreSd?sdType=KA&selectMode=single')
    }
  }
}
</script>

<style lang="less" scoped>
.step-two {
  flex: 1;
  overflow-y: auto;
  padding: 5px 0;
  /deep/.van-collapse {
    .van-collapse-item {
      background-color: #fff;
      .van-collapse-item__title {
        background-color: #e8effc;
        font-weight: bold;
        padding: 5px 10px;
        margin-bottom: 2px;
        .van-cell__title {
          font-weight: bold;
          > span {
            font-size: 14px;
          }
        }
      }
      .van-collapse-item__content {
        padding: 0;
        padding-top: 10px;
      }
    }
  }
  .form-item,
  .subset-form-item {
    padding: 0 10px;
    margin-bottom: 13px;
    .label {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #333;
      margin-bottom: 8px;
      // 添加必填标记样式
      &.required {
        position: relative;
        padding-left: 12px; // 为星号预留空间
        &::before {
          content: '*';
          color: #ff4444;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 14px;
          line-height: 1;
        }
      }
      .label-icon {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }
    .custom-field {
      padding: 5px 10px;
      background: #fff;
      border: 1px solid #b9cbed;
      border-radius: 4px;
      font-size: 12px;
      &::placeholder {
        color: #999;
      }
    }
    .custom-radio-field {
      padding: 0;
      font-size: 13px;
      border: none;
    }
    .phone-inputs {
      display: flex;
      align-items: center;
      .custom-field {
        flex: 1;
        text-align: center;
      }
      span {
        margin: 0 5px;
      }
    }
    .brand-diversity-tips {
      margin-top: 10px;
      color: #307bff;
      font-size: 11px;
      .tips-item {
        display: flex;
        align-items: center;
        .info-icon {
          margin-right: 3px;
        }
      }
    }
    .select-field {
      display: flex;
      align-items: center;
      min-height: 36px;
      color: #333;
    }
  }
  .custom-label {
    display: flex;
    align-items: center;
    .label-icon {
      width: 16px;
      height: 16px;
      margin-left: 3px;
    }
  }
}
</style>
